/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Chat_Conversation_Empty_TitleInputs */

const en_case_chat_conversation_empty_title = /** @type {(inputs: Case_Chat_Conversation_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversation yet`)
};

const pt_br2_case_chat_conversation_empty_title = /** @type {(inputs: Case_Chat_Conversation_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conversa ainda`)
};

/**
* | output |
* | --- |
* | "No conversation yet" |
*
* @param {Case_Chat_Conversation_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_conversation_empty_title = /** @type {((inputs?: Case_Chat_Conversation_Empty_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Conversation_Empty_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_conversation_empty_title(inputs)
	return pt_br2_case_chat_conversation_empty_title(inputs)
});